'use strict';

import React from 'react';
import ReactDOM from 'react-dom';


export {Stepone};

class Stepone extends React.Component {
    constructor(props) {
        super(props);
    }


    render() {

        return (
            <div className={!this.props.active ? 'd-none' : ''}>
                <div className="trade-in-box__step-form__categories">
                    {this.props.categories.map((category) => (
                        <div className="trade-in-box__step-form__categories__item"
                             key={"category" + category.id_category}>
                            <input type="radio" id={"trade-in-category-" + category.id_category} name="id_category" title={category.name}
                                   value={category.id_category}
                                   checked={category.id_category == this.props.idCategory}
                                   onChange={() => this.props.setCategory(parseInt(category.id_category))}/>
                            <label htmlFor={"trade-in-category-" + category.id_category}>
                            <span className="trade-in-box__step-form__categories__ico">
                                <img className="img-default"
                                     src={"/data/categoryicons/c" + category.id_category + ".svg"} alt={category.name}/>
                                <img className="img-active"
                                     src={"/data/categoryicons/c" + category.id_category + "-h.svg"}
                                     alt={category.name}/>
                            </span>
                                <span className="trade-in-box__step-form__categories__txt">{category.name}</span>
                            </label>
                        </div>
                    ))}
                </div>
                <button className="btn btn-lg btn-primary"
                        type="button" disabled={!this.props.idCategory}
                        onClick={() => this.props.setStep(2)}
                >{lajax.t('Заполнить данные о товаре')}</button>
            </div>
        );
    }
}
